<template>
  <el-tabs
    v-model="taskActiveTab"
    stretch
    style="border: 2px solid #ebeef5; width: 100%; min-height: 65vh"
    @tab-click="tabClicked"
    type="card"
    ref="logsTab"
  >
    <el-tab-pane label="Details" name="Details" lazy
      ><el-card
        shadow="never"
        style="margin: 0 5px 0 5px"
        class="card"
        v-if="itemsToShow.length > 0"
      >
        <div slot="header">
          <i class="el-icon-d-arrow-right" style="padding-right: 5px" />Run
          Information
        </div>
        Task Name: <b>{{ activeRecord.taskName }}</b
        ><br />
        Result: <b>{{ activeRecord.result }}</b
        ><br />
        Started At: <b>{{ activeRecord.createdAt }}</b
        ><br />
        Duration: <b>{{ activeRecord.duration }}</b
        ><br />
        Run By: <b>{{ activeRecord.runBy }}</b
        ><br />
        Package: <b>{{ activeRecord.jobName }}</b
        ><br />
      </el-card>
      <div v-if="activeRecord">
        <el-card
          shadow="never"
          style="margin: 5px 5px 0 5px"
          class="card"
          v-if="itemsToShow.length > 0"
        >
          <div slot="header">
            <i
              class="el-icon-d-arrow-right"
              style="padding-right: 5px"
            />General Task Information
          </div>
          Type: <b>{{ activeRecord.type }}</b
          ><br />
          Multiplication Factor: <b>{{ activeRecord.factor }}</b
          ><br />
        </el-card>

        <el-card
          shadow="never"
          style="margin: 5px 5px 0 5px"
          class="card"
          v-if="itemsToShow.length > 0"
        >
          <div slot="header">
            <i
              class="el-icon-d-arrow-right"
              style="padding-right: 5px"
            />Source:
            {{ activeRecord.source }}
          </div>
          <div
            v-if="
              historyDetails.source &&
              activeRecord.source === 'Single Cube' &&
              historyDetails.source.taskHistoryCube
            "
          >
            Cube Name:

            <b>{{
              historyDetails.source &&
              historyDetails.source.taskHistoryCube.name
            }}</b
            ><br />
            <div
              v-for="(dim, index) in historyDetails.source.taskHistoryDims"
              :key="dim.name"
            >
              <br />
              Dimension Name:
              <b>{{
                historyDetails.source &&
                historyDetails.source.taskHistoryDims[index].name
              }}</b
              ><br />
              Element Selected:
              <b>{{
                historyDetails.source &&
                historyDetails.source.taskHistoryDims[index].selection
              }}</b
              ><br />
              Element Type:
              <b>{{
                historyDetails.source &&
                historyDetails.source.taskHistoryDims[index].selectionType
              }}</b
              ><br />
              Alias Selected:
              <b>{{
                historyDetails.source &&
                historyDetails.source.taskHistoryDims[index].selectionAlias
              }}</b
              ><br />
            </div>
          </div>
          <div v-if="activeRecord.source === 'Multiple Cubes'">
            <div v-for="(dim, index) in historyDetails.source" :key="dim.name">
              <br v-if="index > 0" />
              Dimension Name:
              <b>{{
                historyDetails.source && historyDetails.source[index].name
              }}</b
              ><br />
              Element Selected:
              <b>{{
                historyDetails.source && historyDetails.source[index].selection
              }}</b
              ><br />
              Element Type:
              <b>{{
                historyDetails.source &&
                historyDetails.source[index].selectionType
              }}</b
              ><br />
              Alias Selected:
              <b>{{
                historyDetails.source &&
                historyDetails.source[index].selectionAlias
              }}</b
              ><br />
            </div>
          </div>
          <div v-if="activeRecord.source === 'Value'">
            Value: <b>{{ activeRecord.value }}</b>
          </div>
        </el-card>
        <el-card
          shadow="never"
          style="margin: 5px 5px 0 5px"
          class="card"
          v-if="itemsToShow.length > 0"
        >
          <div slot="header">
            <i
              class="el-icon-d-arrow-right"
              style="padding-right: 5px"
            />Target:
            {{ activeRecord.target }}
          </div>
          <div
            v-if="
              historyDetails.target &&
              activeRecord.target &&
              historyDetails.target.taskHistoryCube &&
              activeRecord.target.endsWith('Cube')
            "
          >
            Cube Name:
            <b>{{
              historyDetails.target &&
              historyDetails.target.taskHistoryCube.name
            }}</b
            ><br />
            <div
              v-for="(dim, index) in historyDetails.target.taskHistoryDims"
              :key="dim.name"
            >
              <br />
              Dimension Name:
              <b>{{
                historyDetails.target &&
                historyDetails.target.taskHistoryDims[index].name
              }}</b
              ><br />
              Element Selected:
              <b>{{
                historyDetails.target &&
                historyDetails.target.taskHistoryDims[index].selection
              }}</b
              ><br />
              Element Type:
              <b>{{
                historyDetails.target &&
                historyDetails.target.taskHistoryDims[index].selectionType
              }}</b
              ><br />
              Alias Selected:
              <b>{{
                historyDetails.target &&
                historyDetails.target.taskHistoryDims[index].selectionAlias
              }}</b
              ><br />
            </div>
          </div>
          <div v-if="activeRecord.target === 'Multiple Cubes'">
            <div v-for="(dim, index) in historyDetails.target" :key="dim.name">
              <br v-if="index > 0" />
              Dimension Name:
              <b>{{
                historyDetails.target && historyDetails.target[index].name
              }}</b
              ><br />
              Element Selected:
              <b>{{
                historyDetails.target && historyDetails.target[index].selection
              }}</b
              ><br />
              Element Type:
              <b>{{
                historyDetails.target &&
                historyDetails.target[index].selectionType
              }}</b
              ><br />
              Alias Selected:
              <b>{{
                historyDetails.target &&
                historyDetails.target[index].selectionAlias
              }}</b
              ><br />
            </div>
          </div>
        </el-card>
      </div>
    </el-tab-pane>
    <el-tab-pane label="Log" name="Log" lazy
      ><el-table :data="logData">
        <el-table-column prop="createdAt" label="Timestamp" :min-width="25" />
        <el-table-column prop="message" label="Message" :min-width="60" />
        <el-table-column
          :min-width="15"
          v-if="logData.includes((record) => record.processErrorLogId)"
        >
          <template slot-scope="scope">
            <el-button
              v-if="scope.row.processErrorLogId"
              type="text"
              @click="
                setShowModal();
                recordSelected = scope.row;
              "
              >Error Log</el-button
            >
          </template></el-table-column
        >
      </el-table></el-tab-pane
    >
  </el-tabs>
</template>
<script>
import { mapState } from "vuex";

export default {
  props: {
    showModal: Boolean,
    historyDetails: Object,
    itemsToShow: Array,
    activeTab: String,
    activeRecord: Object,

    logData: Array,
  },
  data() {
    return {
      taskActiveTab: this.activeTab,

      //hi igh
      //logData: [],
      timezone:
        process.env.VUE_APP_SERVER_TIMEZONE ||
        Intl.DateTimeFormat().resolvedOptions().timeZone,
    };
  },
  computed: {
    ...mapState([
      "currentTaskName",
      "instanceId",
      "taskId",
      "isUserLoggedIn",
      "environmentId",
    ]),
  },
  methods: {
    tabClicked(tab) {
      this.$emit("tabClicked", tab);
    },
    setShowModal() {
      this.$emit("setShowModal");
    },
  },
};
</script>
<style scoped>
.card {
  font-size: 14px;
  color: #606266;
}
.el-card :deep(.el-card__header) {
  background-color: #f0f0f0;
  padding: 10px 20px;
}
.el-card :deep(.el-card__body) {
  padding: 10px 20px;
}
</style>